// Helper to build season selector options

import { SeasonOption } from "./types";

interface Season {
  id: number;
  name: string;
}

export function buildSeasonOptions(
  seasons: Season[],
  activeSeasonId: number | null,
): SeasonOption[] {
  return seasons.map((season) => ({
    seasonId: season.id,
    seasonName: season.name,
    label: season.name,
    isDefault: season.id === activeSeasonId,
  }));
}

export function optionKey(opt: SeasonOption): string {
  return `${opt.seasonId}`;
}

export function parseOptionKey(key: string): {
  seasonId: number;
} {
  return { seasonId: Number(key) };
}
